import React, { useState } from 'react'
import { useGetAttemptDetaisQuery } from 'src/api/trainingPackages/trainingPackages'
import ModulesPreview from 'src/pages/microtraining/CreateEditModule/ModulesPreview'

export default function AttemptDetails({ attemptId, userId, trainingId, onClose }) {
  const [moduleIndex, setModuleIndex] = useState(0)
  const { data } = useGetAttemptDetaisQuery({ id: trainingId, userId, attemptId })

  const modulePreview = data?.modules[moduleIndex]
  console.log(modulePreview)

  const completedModules = data?.completedModules?.find(el => el.trainingModuleId == modulePreview.id)

  console.log(completedModules)

  const onNextModule = () => {
    if (moduleIndex === data.modules.length - 1) {
      onClose()
    }
    setModuleIndex(moduleIndex + 1)
  }

  return (
    data && (
      <ModulesPreview
        onNextModule={onNextModule}
        open={true}
        onClose={onClose}
        isAttemptPreview={true}
        completedModules={completedModules?.steps}
        modules={modulePreview?.steps}
        theme={modulePreview?.theme || 'THEME_1'}
      />
    )
  )
}
